
import { controls } from "../controls";

const voter = {
  label: "Voter",
  pageLabel: "Voter",
  starting: true,
  url: "voter",
  pageType: "history",
  formTabs: {
    allTabs: [
      { label: "Profile", uid: "profile", style: { fontFamily: "verdana" } },
      { label: "Timeline", uid: "timeline", style: { fontFamily: "verdana" } },
      { label: "Office Visit", uid: "officevisit", style: { fontFamily: "verdana" } },
      { label: "Complaints", uid: "complaints", style: { fontFamily: "verdana" }},
      { label: "Outward", uid: "outward", style: { fontFamily: "verdana" } },
      { label: "Event", uid: "event", style: { fontFamily: "verdana" } },
      { label: "Relations", uid: "relations", style: { fontFamily: "verdana" } },
      { label: "Family", uid: "family", style: { fontFamily: "verdana" } },
    ]
  },
  filter: [
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Voter Name",
      label: "Voter Name",
    
    },
    {
      inputType: "text",
      tab: "filter",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "Voter Name",
      label: "",
      name: "voter_name",
      description: "Enter Voter Name"
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
    
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      
      label: "Mobile",
    
    },
    {
      inputType: "text",
      tab: "filter",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "Mobile No",
      label: "",
      name: "mobile",
      description: "Enter mobile"
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
    
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "No Of Records",
    
    },
    {
      inputType: "text",
      tab: "filter",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "Per Page",
      label: "",
      name: "per_page",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
    
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "E-Vol Name",
    
    },
    {
      inputType: "text",
      tab: "filter",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "E-Vol Name",
      label: "",
      name: "e_vol_name",
      description: "Enter E-Vol Name"
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
    
    },
    
   
  ],
  form: [
    {
      widths: "col-lg-12",
      tab:"profile",
      subComponents: [
        {
          inputType: "displaytext",
          tab:"profile",
          widths: {
            parent: "col-lg-12",
            children: "col-lg-12"
          },
          label: "Profile Information",
        },
    {
      inputType: "displaytext",
      tab:"profile",
      widths: {
        parent: "col-lg-2",
        children: "col-lg-12"
      },
      label: "Voter Name",
      description: ""
    },
    {
      inputType: "text",
      tab:"profile",
      widths: {
        parent: "col-lg-2",
        children: "col-lg-12"
      },
      placeHolder: "Voter Name",
      name: "VoterName",
      description: ""
    },
    {
      inputType: "displaytext",
      tab:"profile",
      widths: {
        parent: "col-lg-2",
        children: "col-lg-12"
      },
      label: "Family Head",
      description: ""
    },
    {
      inputType: "text",
      tab:"profile",
      widths: {
        parent: "col-lg-2",
        children: "col-lg-12"
      },
      placeHolder: "Family Head",
      name: "FamilyHead",
      description: ""
    },
    {
      inputType: "displaytext",
      tab:"profile",
      widths: {
        parent: "col-lg-2",
        children: "col-lg-12"
      },
      label: "E-Vol Name",
      description: ""
    },
    {
      inputType: "text",
      tab:"profile",
      widths: {
        parent: "col-lg-2",
        children: "col-lg-12"
      },
      placeHolder: "E-Vol Name",
      name: "EvolName",
      description: ""
    },
    {
      inputType: "displaytext",
      tab:"profile",
      widths: {
        parent: "col-lg-2",
        children: "col-lg-12"
      },
      label: "E-Vol Mob No",
      description: ""
    },
    {
      inputType: "text",
      tab:"profile",
      widths: {
        parent: "col-lg-2",
        children: "col-lg-12"
      },
      placeHolder: "E-Vol Mob No",
      name: "EvolMobNo",
      description: ""
    },
    {
      inputType: "displaytext",
      
      widths: {
        parent: "col-lg-2",
        children: "col-lg-12"
      },
      label: "P-Vol Name",
      description: ""
    },
    {
      inputType: "text",
      
      widths: {
        parent: "col-lg-2",
        children: "col-lg-12"
      },
      placeHolder: "P-Vol Name",
      name: "PvolName",
      description: ""
    },
    {
      inputType: "displaytext",
      
      widths: {
        parent: "col-lg-2",
        children: "col-lg-12"
      },
      label: "P-Vol Mob No",
      description: ""
    },
    {
      inputType: "text",
      
      widths: {
        parent: "col-lg-2",
        children: "col-lg-12"
      },
      placeHolder: "P-Vol Mob No",
      name: "PvolMobNo",
      description: ""
    },
    {
      inputType: "radio",
      // default:"finish",
      widths: {
        parent: "col-lg-4",
        children: "col-lg-12"
      },
      options: [
        { label: "Male", value: "M" },
        { label: "Female", value: "F" },
      ],
      propType: "string",
       label:"Gender",
      name: "gender",
      description: ""
    },
    
    {
      inputType: "displaytext",
      
      widths: {
        parent: "col-lg-2",
        children: "col-lg-12"
      },
      label: "Voter ID",
      description: ""
    },
    {
      inputType: "text",
      
      widths: {
        parent: "col-lg-2",
        children: "col-lg-12"
      },
      placeHolder: "Voter ID",
      name: "VoterID",
      description: ""
    }, 
    {
      inputType: "displaytext",
      
      widths: {
        parent: "col-lg-2",
        children: "col-lg-12"
      },
      label: "Serial No",
      description: ""
    },
    {
      inputType: "text",
      
      widths: {
        parent: "col-lg-2",
        children: "col-lg-12"
      },
      placeHolder: "Serial No",
      name: "srno",
      description: ""
    }, 
    {
      inputType: "displaytext",
      
      widths: {
        parent: "col-lg-2",
        children: "col-lg-12"
      },
      label: "Region",
      description: ""
    }, 
    {
      inputType: "autocomplete",
      isRequired: true,
      
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-lg-4",
        children: "col-lg-12"
      },
      options: [],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getRegionname",
          fieldType: "string",
          filters: ["pageData", "regionname"]
        },
        label: "display",
        value: "display"
      },
       placeHolder: "Region",
      name: "region",
      description: ""
    },
    {
      inputType: "displaytext",
      
      widths: {
        parent: "col-lg-2",
        children: "col-lg-12"
      },
      label: "Circle",
      description: ""
    }, 
    {
      inputType: "autocomplete",
      isRequired: true,
      
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-lg-4",
        children: "col-lg-12"
      },
      options: [],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getCircleName",
          fieldType: "string",
          filters: ["pageData", "circlename"],
          dependsOn:[{region:"region.value"}]
        },
        label: "display",
        value: "display"
      },
       placeHolder: "Circle",
      name: "circle",
      description: ""
    },
    {
      inputType: "displaytext",
      
      widths: {
        parent: "col-lg-2",
        children: "col-lg-12"
      },
      label: "Sub Circle",
      description: ""
    }, 
    {
      inputType: "autocomplete",
      isRequired: true,
      
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-lg-4",
        children: "col-lg-12"
      },
      options: [],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getSubCircleName",
          fieldType: "string",
          filters: ["pageData", "subcirclename"],
          dependsOn:[{region:"region.value"},{circle:"circle.value"}]
        },
        label: "display",
        value: "display"
      },
       placeHolder: "Sub Circle",
      name: "subCircle",
      description: ""
    },
    {
      inputType: "displaytext",
      
      widths: {
        parent: "col-lg-2",
        children: "col-lg-12"
      },
      label: "Village",
      description: ""
    }, 
    {
      inputType: "autocomplete",
      isRequired: true,
      
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-lg-4",
        children: "col-lg-12"
      },
      options: [],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getVillageEle",
          fieldType: "string",
          filters: ["pageData", "VillageEle"],
          dependsOn:[{region:"region.value"},{circle:"circle.value"},{subCircle:"subCircle.value"}]
        },
        label: "display",
        value: "display"
      },
       placeHolder: "Village",
      name: "village",
      description: ""
    },
    {
      inputType: "displaytext",
      
      widths: {
        parent: "col-lg-2",
        children: "col-lg-12"
      },
      label: "Booth",
      description: ""
    }, 
    {
      inputType: "autocomplete",
      isRequired: true,
      
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-lg-4",
        children: "col-lg-12"
      },
      options: [],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getBoothEle",
          fieldType: "string",
          filters: ["pageData", "BoothEle"],
          dependsOn:[{region:"region.value"},{circle:"circle.value"},{subCircle:"subCircle.value"},{village:"village.value"}]
        },
        label: "display",
        value: "display"
      },
       placeHolder: "Booth",
      name: "booth",
      description: ""
    },
    {
      inputType: "displaytext",
      
      widths: {
        parent: "col-lg-2",
        children: "col-lg-12"
      },
      label: "Address",
      description: ""
    }, 
    {
      inputType: "text",
      
      widths: {
        parent: "col-lg-4",
        children: "col-lg-12"
      },
      placeHolder: "Address",
      name: "address",
      description: ""
    },
    
    {
      inputType: "displaytext",
      
      widths: {
        parent: "col-lg-2",
        children: "col-lg-12"
      },
      label: "Date of Birth",
      description: ""
    },
    {
        inputType: "date",
        dateType: "ontype",
        
        isRequired: true,
        widths: {
          parent: "col-lg-4",
          children: "col-lg-12"
        },
        placeHolder: "DOB",
        displayFormat: "DD/MM/YYYY",
        outputFormat: "YYYYMMDD",
        name: "dob",
        description: ""
    },
    {
      inputType: "displaytext",
      
      widths: {
        parent: "col-lg-2",
        children: "col-lg-12"
      },
      label: "Age",
      description: ""
    },
    {
        inputType: "showdata",
        
        data: "age",
        textcolor: "black",
        widths: {
          parent: "col-lg-4",
          children: "col-lg-12"
       },
    },
    {
      inputType: "displaytext",
      
      widths: {
        parent: "col-lg-2",
        children: "col-lg-12"
      },
      label: "Voter Designation",
      description: ""
    },
    {
      inputType: "select",
      
      default: "voter",
      widths: {
        parent: "col-lg-4",
        children: "col-lg-12"
      },
      options: [
        
        {
          label: "Booth Incharge",
          value: "boothincharge"
        },
        
        {
          label: "E-Volunteer",
          value: "evolunteer"
        },
        {
          label: "P-Volunteer",
          value: "pvolunteer"
        },
        {
          label: "Reporter",
          value: "reporter"
        },
      ],
      placeHolder: "Voter Designation",
      name: "voterDesignation",
      description: ""
  },
    
    
    
   ],
   },



   {
    widths: "col-lg-12",
    tab:"profile",
    subComponents: [
      {
        inputType: "displaytext",
        
        widths: {
          parent: "col-lg-12",
          children: "col-lg-12"
        },
        label: "Address Information",
      }, 
    
    {
      inputType: "displaytext",
      
      widths: {
        parent: "col-lg-2",
        children: "col-lg-12"
      },
      label: "Apartment Name",
      description: ""
    },
    {
      inputType: "text",
      
      widths: {
        parent: "col-lg-4",
        children: "col-lg-12"
      },
      placeHolder: "Apartment Name",
      name: "apartmentName",
      description: ""
    },
    {
      inputType: "displaytext",
      
      widths: {
        parent: "col-lg-2",
        children: "col-lg-12"
      },
      label: "House Number",
      description: ""
    },
    {
      inputType: "text",
      
      widths: {
        parent: "col-lg-4",
        children: "col-lg-12"
      },
      placeHolder: "House Number",
      name: "housenumber",
      description: ""
    },
    {
      inputType: "displaytext",
      
      widths: {
        parent: "col-lg-2",
        children: "col-lg-12"
      },
      label: "Zip Code",
      description: ""
    },
    {
      inputType: "numberonly",
      
      widths: {
        parent: "col-lg-4",
        children: "col-lg-12"
      },
      placeHolder: "Zip Code",
      name: "zipCode",
      description: ""
    },
    {
      inputType: "displaytext",
      
      widths: {
        parent: "col-lg-2",
        children: "col-lg-12"
      },
      label: "Mobile Number1",
      description: ""
    },
    {
      inputType: "numberonly",
      
      widths: {
        parent: "col-lg-4",
        children: "col-lg-12"
      },
      placeHolder: "Mobile Number1",
      name: "mobilenumber1",
      description: ""
    },
    {
      inputType: "displaytext",
      
      widths: {
        parent: "col-lg-2",
        children: "col-lg-12"
      },
      label: "Mobile Number2",
      description: ""
    },
    {
      inputType: "numberonly",
      
      widths: {
        parent: "col-lg-4",
        children: "col-lg-12"
      },
      placeHolder: "Mobile Number2",
      name: "mobilenumber2",
      description: ""
    },
    {
      inputType: "displaytext",
      
      widths: {
        parent: "col-lg-2",
        children: "col-lg-12"
      },
      label: "Landline",
      description: ""
    },
    {
      inputType: "numberonly",
      
      widths: {
        parent: "col-lg-4",
        children: "col-lg-12"
      },
      placeHolder: "Landline",
      name: "landline",
      description: ""
    },
    
    
    
    ],
    },

    {
      widths: "col-lg-12",
      tab:"profile",
      subComponents: [
        {
          inputType: "displaytext",
          
          widths: {
            parent: "col-lg-12",
            children: "col-lg-12"
          },
          label: "Social Networks",
        },
        {
          inputType: "displaytext",
          
          widths: {
            parent: "col-lg-2",
            children: "col-lg-12"
          },
          label: "Email",
          description: ""
        },
        {
          inputType: "text",
          
          widths: {
            parent: "col-lg-4",
            children: "col-lg-12"
          },
          placeHolder: "Email",
          name: "email",
          description: ""
        },
        {
          inputType: "displaytext",
          
          widths: {
            parent: "col-lg-2",
            children: "col-lg-12"
          },
          label: "Facebook",
          description: ""
        },
        {
          inputType: "text",
          
          widths: {
            parent: "col-lg-4",
            children: "col-lg-12"
          },
          placeHolder: "Facebook",
          name: "facebook",
          description: ""
        },
        {
          inputType: "displaytext",
          
          widths: {
            parent: "col-lg-2",
            children: "col-lg-12"
          },
          label: "Twitter",
          description: ""
        },
        {
          inputType: "text",
          
          widths: {
            parent: "col-lg-4",
            children: "col-lg-12"
          },
          placeHolder: "Twitter",
          name: "twitter",
          description: ""
        },
        
     
      {
        inputType: "displaytext",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "Department",
        description: ""
      }, 
      {
        inputType: "autocomplete",
        isRequired: true,
        
        default: "",
        elementProps: {
          stayOpen: false,
          removeSelected: true,
          disabled: false,
          rtl: false
        },
        widths: {
          parent: "col-lg-4",
          children: "col-lg-12"
        },
        options: [],
        ajaxLoad: true,
        ajaxOptions: {
          query: {
            dialect: "mongodb",
            query: "getDepartmentEle",
            fieldType: "string",
            filters: ["pageData", "departmentEle"]
          },
          label: "display",
          value: "display"
        },
         placeHolder: "Department",
        name: "Department",
        description: ""
      },
      {
        inputType: "displaytext",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "Sub Department",
        description: ""
      }, 
      {
        inputType: "autocomplete",
        isRequired: true,
        
        default: "",
        elementProps: {
          stayOpen: false,
          removeSelected: true,
          disabled: false,
          rtl: false
        },
        widths: {
          parent: "col-lg-4",
          children: "col-lg-12"
        },
        options: [],
        ajaxLoad: true,
        ajaxOptions: {
          query: {
            dialect: "mongodb",
            query: "getSubDepartmentEle",
            fieldType: "string",
            filters: ["pageData", "SubDepartmentEle"]
          },
          label: "display",
          value: "display"
        },
         placeHolder: "Sub Department",
        name: "subDepartment",
        description: ""
      },
      {
        inputType: "displaytext",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "Designation",
        description: ""
      }, 
      {
        inputType: "autocomplete",
        isRequired: true,
        
        default: "",
        elementProps: {
          stayOpen: false,
          removeSelected: true,
          disabled: false,
          rtl: false
        },
        widths: {
          parent: "col-lg-4",
          children: "col-lg-12"
        },
        options: [],
        ajaxLoad: true,
        ajaxOptions: {
          query: {
            dialect: "mongodb",
            query: "getDesignationEle",
            fieldType: "string",
            filters: ["pageData", "DesignationEle"]
          },
          label: "display",
          value: "display"
        },
         placeHolder: "Designation",
        name: "designation",
        description: ""
      },
      
      ],
      },

      {
        widths: "col-lg-12",
        tab:"profile",
        subComponents: [
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-lg-12",
              children: "col-lg-12"
            },
            label: "Education Networks",
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-lg-2",
              children: "col-lg-12"
            },
            label: "Education",
            description: ""
          },
          {
            inputType: "autocomplete",
            isRequired: true,
            
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-lg-4",
              children: "col-lg-12"
            },
            options: [],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getEducationEle",
                fieldType: "string",
                filters: ["pageData", "EducationEle"]
              },
              label: "display",
              value: "display"
            },
             placeHolder: "Education",
            name: "education",
            description: ""
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-lg-2",
              children: "col-lg-12"
            },
            label: "Occupation",
            description: ""
          },
          {
            inputType: "autocomplete",
            isRequired: true,
            
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-lg-4",
              children: "col-lg-12"
            },
            options: [],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getOccupationEle",
                fieldType: "string",
                filters: ["pageData", "OccupationEle"]
              },
              label: "display",
              value: "display"
            },
             placeHolder: "Occupation",
            name: "occupation",
            description: ""
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-lg-2",
              children: "col-lg-12"
            },
            label: "Blood Group",
            description: ""
          },
          {
            inputType: "autocomplete",
            isRequired: true,
            
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-lg-4",
              children: "col-lg-12"
            },
            options: [],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getBloodGroup",
                fieldType: "string",
                filters: ["pageData", "BloodGroup"]
              },
              label: "display",
              value: "display"
            },
             placeHolder: "Blood Group",
            name: "bloodgroup",
            description: ""
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-lg-2",
              children: "col-lg-12"
            },
            label: "Caste",
            description: ""
          },
          {
            inputType: "autocomplete",
            isRequired: true,
            
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-lg-4",
              children: "col-lg-12"
            },
            options: [],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getCasteEle",
                fieldType: "string",
                filters: ["pageData", "CasteEle"]
              },
              label: "display",
              value: "display"
            },
             placeHolder: "Caste",
            name: "caste",
            description: ""
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-lg-2",
              children: "col-lg-12"
            },
            label: "Party",
            description: ""
          },
          {
            inputType: "autocomplete",
            isRequired: true,
            
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-lg-4",
              children: "col-lg-12"
            },
            options: [],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getPartyEle",
                fieldType: "string",
                filters: ["pageData", "PartyEle"]
              },
              label: "display",
              value: "display"
            },
             placeHolder: "Party",
            name: "party",
            description: ""
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-lg-2",
              children: "col-lg-12"
            },
            label: "Candidate",
            description: ""
          },
          {
            inputType: "autocomplete",
            isRequired: true,
            
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-lg-4",
              children: "col-lg-12"
            },
            options: [],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getCandidateEle",
                fieldType: "string",
                filters: ["pageData", "CandidateEle"]
              },
              label: "display",
              value: "display"
            },
             placeHolder: "Candidate",
            name: "candidate",
            description: ""
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-lg-2",
              children: "col-lg-12"
            },
            label: "Voter Type",
            description: ""
          },
          {
              inputType: "select",
              
              default: "",
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              options: [
                {
                  label: "Positive",
                  value: "Positive"
                },
                {
                  label: "Negative",
                  value: "Negative"
                },
                {
                  label: "Known",
                  value: "Known"
                },
                {
                  label: "Unknown",
                  value: "Unknown"
                },
                {
                  label: "Doubtful",
                  value: "Doubtful"
                },
                
              ],
              placeHolder: "Voter Type",
              name: "votertype",
              description: ""
          },
          
          {
              inputType: "checkbox",
              isRequired: true,
              default: "true",
              
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              // options:[
              //  { name:"livingoutname",value:"livingout"}
              // ],
              
              placeHolder: "Input",
              label: "Living Out Station",
              name: "livingoutstation",
              description: ""
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-lg-1",
              children: "col-lg-12"
            },
            label: "City",
            description: ""
          },
          {
            inputType: "autocomplete",
            isRequired: true,
            
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-lg-3",
              children: "col-lg-12"
            },
            options: [],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getCityEle",
                fieldType: "string",
                filters: ["pageData", "CityEle"]
              },
              label: "display",
              value: "display"
            },
             placeHolder: "CityEle",
            name: "cityEle",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            
            widths: {
              parent: "col-lg-2",
              children: "col-lg-12"
            },
            placeHolder: "Input",
            label: "Died Voter",
            name: "diedvoter",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            
            widths: {
              parent: "col-lg-2",
              children: "col-lg-12"
            },
            placeHolder: "Input",
            label: "Duplicated Voter",
            name: "duplicatedVoter",
            description: ""
          },
          

              
        ],
        },





        {
          widths: "col-lg-12",
          tab:"timeline",
          subComponents: [
             {
              inputType: "timeline",
              widths: {
                parent: "col-lg-6",
                children: "col-lg-12"
              },
              label: "Development Work Report",
              data:[],
              fromGetPage:"development",
              getval:["workType","scheme","detailsofWork"],
              name:"TimelineByVillage",
              description: "",
              defaultFind:"village"
              
            },
            {
              inputType: "timeline",
              widths: {
                parent: "col-lg-6",
                children: "col-lg-12"
              },
              label: "Beneficiary Work Report",
              data:[],
              fromGetPage:"beneficiary",
              getval:["department","scheme","detailsofWork"],
              name:"TimelineByvoterID",
              description: "",
              defaultFind:"VoterID"
            },

          ],
        },
        






        {
          widths: "col-lg-12",
          tab: "officevisit",
          subComponents: [
        {
              inputType: "displaytext",
              // 
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Reason Type",
              description: ""
        },
        {
          inputType: "autocomplete",
          isRequired: true,
          
          default: "",
          elementProps: {
            stayOpen: false,
            removeSelected: true,
            disabled: false,
            rtl: false
          },
          widths: {
            parent: "col-lg-4",
            children: "col-lg-12"
          },
          options: [],
          ajaxLoad: true,
          ajaxOptions: {
            query: {
              dialect: "mongodb",
              query: "getReasonEle",
              fieldType: "string",
              filters: ["pageData", "ReasonEle"]
            },
            label: "display",
            value: "display"
          },
           placeHolder: "Reason Type",
          name: "reasonType",
          description: ""
        },  
        {
          inputType: "displaytext",
          // 
          widths: {
            parent: "col-lg-2",
            children: "col-lg-12"
          },
          label: "Visit Date",
          description: ""
        },
        
        {
            inputType: "date",
            dateType: "ontype",
            
            isRequired: true,
            widths: {
              parent: "col-lg-3",
              children: "col-lg-12"
            },
            default:"today",
            // placeHolder:"as",
            displayFormat: "DD/MM/YYYY",
            outputFormat: "YYYYMMDD",
            name: "visitDate",
            description: ""
        },





        {
          inputType: "displaytext",
          // 
          widths: {
            parent: "col-lg-2",
            children: "col-lg-12"
          },
          label: "Visit Reason",
          description: ""
        },
        {
          inputType: "autocomplete",
          isRequired: true,

          default: "",
          elementProps: {
            stayOpen: false,
            removeSelected: true,
            disabled: false,
            rtl: false
          },
          widths: {
            parent: "col-lg-9",
            children: "col-lg-12"
          },
          options: [],
          ajaxLoad: true,
          ajaxOptions: {
            query: {
              dialect: "mongodb",
              query: "getVisitReasonEle",
              fieldType: "string",
              filters: ["pageData", "VisitReasonEle"]
            },
            label: "display",
            value: "display"
          },
           placeHolder: "Visit Reason",
          name: "visitReason",
          description: ""
        },   
        {
          inputType: "displaytext",
          // 
          widths: {
            parent: "col-lg-2",
            children: "col-lg-12"
          },
          label: "Remarks",
          description: ""
        },   
        {
          inputType: "text",
          
          widths: {
            parent: "col-lg-9",
            children: "col-lg-12"
          },
          placeHolder: "Remarks",
          name: "remarks",
          description: ""
        },
        {
          inputType: "displaytext",
          // 
          widths: {
            parent: "col-lg-2",
            children: "col-lg-12"
          },
          label: "Tags",
          description: ""
        },   
        {
          inputType: "text",
          
          widths: {
            parent: "col-lg-9",
            children: "col-lg-12"
          },
          placeHolder: "Tags",
          name: "tags",
          description: ""
        },     
        ],
        },




        {
          widths: "col-lg-12",
          tab:"complaints",
          subComponents: [
            {
              inputType: "displaytext",
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Issue Type",
              description: ""
            },
            {
              inputType: "autocomplete",
              isRequired: true,
  
              default: "",
              elementProps: {
                stayOpen: false,
                removeSelected: true,
                disabled: false,
                rtl: false
              },
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              options: [],
              ajaxLoad: true,
              ajaxOptions: {
                query: {
                  dialect: "mongodb",
                  query: "getIssueTypeEle",
                  fieldType: "string",
                  filters: ["pageData", "IssueTypeEle"]
                },
                label: "display",
                value: "display"
              },
               placeHolder: "Issue Type",
              name: "issueType",
              description: ""
            },
            {
              inputType: "displaytext",
              // 
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Date of Issue",
              description: ""
            },
            {
                inputType: "date",
                dateType: "ontype",
                
                isRequired: true,
                widths: {
                  parent: "col-lg-4",
                  children: "col-lg-12"
                },
                displayFormat: "DD/MM/YYYY",
                outputFormat: "YYYYMMDD",
                name: "dateofIssue",
                description: ""
            },
            {
              inputType: "displaytext",
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Subject",
              description: ""
            },
            {
              inputType: "autocomplete",
              isRequired: true,
  
              default: "",
              elementProps: {
                stayOpen: false,
                removeSelected: true,
                disabled: false,
                rtl: false
              },
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              options: [],
              ajaxLoad: true,
              ajaxOptions: {
                query: {
                  dialect: "mongodb",
                  query: "getSubjectEle",
                  fieldType: "string",
                  filters: ["pageData", "SubjectEle"]
                },
                label: "display",
                value: "display"
              },
               placeHolder: "Subject",
              name: "subject",
              description: ""
            },
            {
              inputType: "displaytext",
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Issue Status",
              description: ""
            },
            {
              inputType: "autocomplete",
              isRequired: true,
  
              default: "",
              elementProps: {
                stayOpen: false,
                removeSelected: true,
                disabled: false,
                rtl: false
              },
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              options: [],
              ajaxLoad: true,
              ajaxOptions: {
                query: {
                  dialect: "mongodb",
                  query: "getIssueStatusEle",
                  fieldType: "string",
                  filters: ["pageData", "IssueStatusEle"]
                },
                label: "display",
                value: "display"
              },
               placeHolder: "Issue Status",
              name: "issueStatus",
              description: ""
            },
            {
              inputType: "displaytext",
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Priority",
              description: ""
            },
            {
              inputType: "autocomplete",
              isRequired: true,
  
              default: "",
              elementProps: {
                stayOpen: false,
                removeSelected: true,
                disabled: false,
                rtl: false
              },
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              options: [],
              ajaxLoad: true,
              ajaxOptions: {
                query: {
                  dialect: "mongodb",
                  query: "getPriorityEle",
                  fieldType: "string",
                  filters: ["pageData", "PriorityEle"]
                },
                label: "display",
                value: "display"
              },
               placeHolder: "Priority",
              name: "priority",
              description: ""
            },
            {
              inputType: "displaytext",
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Reference",
              description: ""
            },
            {
              inputType: "autocomplete",
              isRequired: true,
  
              default: "",
              elementProps: {
                stayOpen: false,
                removeSelected: true,
                disabled: false,
                rtl: false
              },
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              options: [],
              ajaxLoad: true,
              ajaxOptions: {
                query: {
                  dialect: "mongodb",
                  query: "getReferenceEle",
                  fieldType: "string",
                  filters: ["pageData", "ReferenceEle"]
                },
                label: "display",
                value: "display"
              },
               placeHolder: "Reference",
              name: "reference",
              description: ""
            },
            {
              inputType: "displaytext",
              // 
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Description",
              description: ""
            },   
            {
              inputType: "text",
              
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              placeHolder: "Description",
              name: "description",
              description: ""
            }, 
            {
              inputType: "fileupload",
              widths: {
                parent: "col-lg-6",
                children: "col-lg-12"
              },
              label: "Attachment",
              name: "attachment",
              placeholder: {
                type: "text",
                value:
                  "Attachment"
              },
              files: [],
              multiple: true
              
            },
            {
              inputType: "displaytext",
              
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Department",
              description: ""
            }, 
            {
              inputType: "autocomplete",
              isRequired: true,
              
              default: "",
              elementProps: {
                stayOpen: false,
                removeSelected: true,
                disabled: false,
                rtl: false
              },
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              options: [],
              ajaxLoad: true,
              ajaxOptions: {
                query: {
                  dialect: "mongodb",
                  query: "getDepartmentEle",
                  fieldType: "string",
                  filters: ["pageData", "departmentEle"]
                },
                label: "display",
                value: "display"
              },
               placeHolder: "Department",
              name: "DepartmentComp",
              description: ""
            },
            {
              inputType: "displaytext",
              
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Responsible Officer",
              description: ""
            }, 
            {
              inputType: "autocomplete",
              isRequired: true,
              
              default: "",
              elementProps: {
                stayOpen: false,
                removeSelected: true,
                disabled: false,
                rtl: false
              },
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              options: [],
              ajaxLoad: true,
              ajaxOptions: {
                query: {
                  dialect: "mongodb",
                  query: "getResposibleOfficerEle",
                  fieldType: "string",
                  filters: ["pageData", "ResposibleOfficerEle"]
                },
                label: "display",
                value: "display"
              },
               placeHolder: "Responsible Officer",
              name: "ResponsibleOfficer",
              description: ""
            },
            {
              inputType: "displaytext",
              
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Assisgned User",
              description: ""
            }, 
            {
              inputType: "autocomplete",
              isRequired: true,
              
              default: "",
              elementProps: {
                stayOpen: false,
                removeSelected: true,
                disabled: false,
                rtl: false
              },
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              options: [],
              ajaxLoad: true,
              ajaxOptions: {
                query: {
                  dialect: "mongodb",
                  query: "getAssisgnedUserEle",
                  fieldType: "string",
                  filters: ["pageData", "AssisgnedUserEle"]
                },
                label: "display",
                value: "display"
              },
               placeHolder: "Assisgned User",
              name: "AssisgnedUser",
              description: ""
            },
            {
              inputType: "displaytext",
              
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Issue Number",
              description: ""
            },
            {
              inputType: "numberonly",
              
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              placeHolder: "Issue Number",
              name: "issueNumber",
              description: ""
            },
            {
              inputType: "displaytext",
              // 
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Issue Remarks",
              description: ""
            },   
            {
              inputType: "text",
              
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              placeHolder: "Issue Remarks",
              name: "issueremarks",
              description: ""
            },
            {
              inputType: "checkbox",
              isRequired: true,
              default: "true",
              
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              placeHolder: "Input",
              label: "Take Action",
              name: "takeActiona",
              description: ""
            },
            

          ],
        },





        {
          widths: "col-lg-12",
          tab:"outward",
          subComponents: [
            {
              inputType: "displaytext",
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Subject",
              description: ""
            },
            {
              inputType: "autocomplete",
              isRequired: true,
  
              default: "",
              elementProps: {
                stayOpen: false,
                removeSelected: true,
                disabled: false,
                rtl: false
              },
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              options: [],
              ajaxLoad: true,
              ajaxOptions: {
                query: {
                  dialect: "mongodb",
                  query: "getOutwardSubjectEle",
                  fieldType: "string",
                  filters: ["pageData", "OutwardSubjectEle"]
                },
                label: "display",
                value: "display"
              },
               placeHolder: "Subject",
              name: "outwardSubject",
              description: ""
            },
            {
              inputType: "displaytext",
              // 
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Date",
              description: ""
            },
            {
                inputType: "date",
                dateType: "ontype",
                
                isRequired: true,
                widths: {
                  parent: "col-lg-4",
                  children: "col-lg-12"
                },
                displayFormat: "DD/MM/YYYY",
                outputFormat: "YYYYMMDD",
                name: "dateoutward",
                description: ""
            },
            {
              inputType: "displaytext",
              // 
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Message Number",
              description: ""
            },   
            {
              inputType: "numberonly",
              
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              placeHolder: "Outward Message Number",
              name: "messagenumber",
              description: ""
            },
            {
              inputType: "displaytext",
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Letter Template",
              description: ""
            },
            {
              inputType: "autocomplete",
              isRequired: true,
  
              default: "",
              elementProps: {
                stayOpen: false,
                removeSelected: true,
                disabled: false,
                rtl: false
              },
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              options: [],
              ajaxLoad: true,
              ajaxOptions: {
                query: {
                  dialect: "mongodb",
                  query: "getLetterTemplateEle",
                  fieldType: "string",
                  filters: ["pageData", "LetterTemplateEle"]
                },
                label: "display",
                value: "display"
              },
               placeHolder: "Letter Template",
              name: "LetterTemplate",
              description: ""
            },
            {
              inputType: "fileupload",
              widths: {
                parent: "col-lg-6",
                children: "col-lg-12"
              },
              label: "Attachment",
              name: "attachmentletter",
              placeholder: {
                type: "text",
                value:
                  "Attachment"
              },
              files: [],
              multiple: true
            },
            {
              inputType: "texteditor",
              // isRequired: true,
              // tab: "WYSIWYGEditor",
              widths: {
                parent: "col-lg-10",
                children: "col-lg-12"
              },
              // value:lastYearEnd(),
              placeHolder: "Tell a story..",
              label: "Myeditor",
              name: "Myeditor",
              description: "",
              texteditor: "Mytexteditor"
            },

          ],
        },


        {
          widths: "col-lg-12",
          tab:"event",
          subComponents: [
            {
              inputType: "displaytext",
              // 
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Title",
              description: ""
            },   
            {
              inputType: "text",
              
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              placeHolder: "Title",
              name: "title",
              description: ""
            },
            {
              inputType: "displaytext",
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Event Type",
              description: ""
            },
            {
              inputType: "autocomplete",
              isRequired: true,
  
              default: "",
              elementProps: {
                stayOpen: false,
                removeSelected: true,
                disabled: false,
                rtl: false
              },
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              options: [],
              ajaxLoad: true,
              ajaxOptions: {
                query: {
                  dialect: "mongodb",
                  query: "getEventTypeEle",
                  fieldType: "string",
                  filters: ["pageData", "EventTypeEle"]
                },
                label: "display",
                value: "display"
              },
               placeHolder: "Event Type",
              name: "EventType",
              description: ""
            },
            {
              inputType: "displaytext",
              // 
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Start Date",
              description: ""
            },
            {
                inputType: "date",
                dateType: "ontype",
                
                isRequired: true,
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                displayFormat: "DD/MM/YYYY",
                outputFormat: "YYYYMMDD",
                name: "startdate",
                description: ""
            },
            {
              inputType: "displaytext",
              // 
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "End Date",
              description: ""
            },
            {
                inputType: "date",
                dateType: "ontype",
                
                isRequired: true,
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                displayFormat: "DD/MM/YYYY",
                outputFormat: "YYYYMMDD",
                name: "enddate",
                description: ""
            },
            {
              inputType: "displaytext",
              
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Phone",
              description: ""
            },
            {
              inputType: "numberonly",
              
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              placeHolder: "Phone",
              name: "phone",
              description: ""
            },
            {
              inputType: "displaytext",
              // 
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Area",
              description: ""
            },   
            {
              inputType: "text",
              
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              placeHolder: "Area",
              name: "area",
              description: ""
            },
            {
              inputType: "displaytext",
              // 
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Venue",
              description: ""
            },   
            {
              inputType: "text",
              
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              placeHolder: "Venue",
              name: "venue",
              description: ""
            },
            {
              inputType: "displaytext",
              // 
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Description",
              description: ""
            },   
            {
              inputType: "text",
              
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              placeHolder: "Description",
              name: "descevent",
              description: ""
            },
            {
              inputType: "fullCalender",
              widths: {
                parent: "col-lg-12",
                children: "col-lg-12"
              },
              label: "DatePicker",
              name: "DatePicker",
              description: "none",
              events: [
               
               
              ]
            },
            
          ],
        },



        {
          widths: "col-lg-12",
          tab:"relations",
          subComponents: [
            {
              inputType: "text",
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              name: "City",
              description: ""
            },

          ],
        },


        {
          widths: "col-lg-12",
          tab:"family",
          subComponents: [
            {
              inputType: "displaytext",
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Father",
              description: ""
            },
            {
              inputType: "autocomplete",
              isRequired: true,
  
              default: "",
              elementProps: {
                stayOpen: false,
                removeSelected: true,
                disabled: false,
                rtl: false
              },
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              options: [],
              ajaxLoad: true,
              ajaxOptions: {
                query: {
                  dialect: "mongodb",
                  query: "getVoterID",
                  fieldType: "string",
                  filters: ["pageData", "VoterID"],
                  dependsOn:[{region:"region.value"},{circle:"circle.value"},{subCircle:"subCircle.value"},{village:"village.value"}]
                },
                label: "display",
                value: "display"
              },
               placeHolder: "Father",
              name: "father",
              description: ""
            },
            {
              inputType: "displaytext",
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Mother",
              description: ""
            },
            {
              inputType: "autocomplete",
              isRequired: true,
  
              default: "",
              elementProps: {
                stayOpen: false,
                removeSelected: true,
                disabled: false,
                rtl: false
              },
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              options: [],
              ajaxLoad: true,
              ajaxOptions: {
                query: {
                  dialect: "mongodb",
                  query: "getVoterID",
                  fieldType: "string",
                  filters: ["pageData", "VoterID"],
                  dependsOn:[{region:"region.value"},{circle:"circle.value"},{subCircle:"subCircle.value"},{village:"village.value"}]
                },
                label: "display",
                value: "display"
              },
               placeHolder: "Mother",
              name: "mother",
              description: ""
            },
            {
              inputType: "displaytext",
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Sister",
              description: ""
            },
            {
              inputType: "autocompletemulti",
              isRequired: true,
  
              default: "",
              elementProps: {
                stayOpen: false,
                removeSelected: true,
                disabled: false,
                rtl: false
              },
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              options: [],
              ajaxLoad: true,
              ajaxOptions: {
                query: {
                  dialect: "mongodb",
                  query: "getVoterID",
                  fieldType: "string",
                  filters: ["pageData", "VoterID"],
                  dependsOn:[{region:"region.value"},{circle:"circle.value"},{subCircle:"subCircle.value"},{village:"village.value"}]
                },
                label: "display",
                value: "display"
              },
               placeHolder: "Sister",
              name: "sister",
              description: ""
            },
            {
              inputType: "displaytext",
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Brother",
              description: ""
            },
            {
              inputType: "autocompletemulti",
              isRequired: true,
  
              default: "",
              elementProps: {
                stayOpen: false,
                removeSelected: true,
                disabled: false,
                rtl: false
              },
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              options: [],
              ajaxLoad: true,
              ajaxOptions: {
                query: {
                  dialect: "mongodb",
                  query: "getVoterID",
                  fieldType: "string",
                  filters: ["pageData", "VoterID"],
                  dependsOn:[{region:"region.value"},{circle:"circle.value"},{subCircle:"subCircle.value"},{village:"village.value"}]
                },
                label: "display",
                value: "display"
              },
               placeHolder: "Brother",
              name: "brother",
              description: ""
            },
            {
              inputType: "displaytext",
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Son",
              description: ""
            },
            {
              inputType: "autocompletemulti",
              isRequired: true,
  
              default: "",
              elementProps: {
                stayOpen: false,
                removeSelected: true,
                disabled: false,
                rtl: false
              },
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              options: [],
              ajaxLoad: true,
              ajaxOptions: {
                query: {
                  dialect: "mongodb",
                  query: "getVoterID",
                  fieldType: "string",
                  filters: ["pageData", "VoterID"],
                  dependsOn:[{region:"region.value"},{circle:"circle.value"},{subCircle:"subCircle.value"},{village:"village.value"}]
                },
                label: "display",
                value: "display"
              },
               placeHolder: "Son",
              name: "son",
              description: ""
            },
            {
              inputType: "displaytext",
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Daughter",
              description: ""
            },
            {
              inputType: "autocompletemulti",
              isRequired: true,
  
              default: "",
              elementProps: {
                stayOpen: false,
                removeSelected: true,
                disabled: false,
                rtl: false
              },
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              options: [],
              ajaxLoad: true,
              ajaxOptions: {
                query: {
                  dialect: "mongodb",
                  query: "getVoterID",
                  fieldType: "string",
                  filters: ["pageData", "VoterID"],
                  dependsOn:[{region:"region.value"},{circle:"circle.value"},{subCircle:"subCircle.value"},{village:"village.value"}]
                },
                label: "display",
                value: "display"
              },
               placeHolder: "Daughter",
              name: "daughter",
              description: ""
            },
            {
              inputType: "displaytext",
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Wife",
              description: "Enter Wife"
            },
            {
              inputType: "autocompletemulti",
              isRequired: true,
  
              default: "",
              elementProps: {
                stayOpen: false,
                removeSelected: true,
                disabled: false,
                rtl: false
              },
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              options: [],
              ajaxLoad: true,
              ajaxOptions: {
                query: {
                  dialect: "mongodb",
                  query: "getVoterID",
                  fieldType: "string",
                  filters: ["pageData", "VoterID"],
                  dependsOn:[{region:"region.value"},{circle:"circle.value"},{subCircle:"subCircle.value"},{village:"village.value"}]
                },
                label: "display",
                value: "display"
              },
               placeHolder: "Wife",
              name: "wife",
              description: ""
            },
            {
              inputType: "displaytext",
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Husband",
              description: ""
            },
            {
              inputType: "autocompletemulti",
              isRequired: true,
  
              default: "",
              elementProps: {
                stayOpen: false,
                removeSelected: true,
                disabled: false,
                rtl: false
              },
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              options: [],
              ajaxLoad: true,
              ajaxOptions: {
                query: {
                  dialect: "mongodb",
                  query: "getVoterID",
                  fieldType: "string",
                  filters: ["pageData", "VoterID"],
                  dependsOn:[{region:"region.value"},{circle:"circle.value"},{subCircle:"subCircle.value"},{village:"village.value"}]
                },
                label: "display",
                value: "display"
              },
               placeHolder: "Husband",
              name: "husband",
              description: ""
            },
            {
              inputType: "displaytext",
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Uncle",
              description: ""
            },
            {
              inputType: "autocompletemulti",
              isRequired: true,
  
              default: "",
              elementProps: {
                stayOpen: false,
                removeSelected: true,
                disabled: false,
                rtl: false
              },
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              options: [],
              ajaxLoad: true,
              ajaxOptions: {
                query: {
                  dialect: "mongodb",
                  query: "getVoterID",
                  fieldType: "string",
                  filters: ["pageData", "VoterID"],
                  dependsOn:[{region:"region.value"},{circle:"circle.value"},{subCircle:"subCircle.value"},{village:"village.value"}]
                },
                label: "display",
                value: "display"
              },
               placeHolder: "Uncle",
              name: "uncle",
              description: ""
            },
            {
              inputType: "displaytext",
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Aunty",
              description: ""
            },
            {
              inputType: "autocompletemulti",
              isRequired: true,
  
              default: "",
              elementProps: {
                stayOpen: false,
                removeSelected: true,
                disabled: false,
                rtl: false
              },
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              options: [],
              ajaxLoad: true,
              ajaxOptions: {
                query: {
                  dialect: "mongodb",
                  query: "getVoterID",
                  fieldType: "string",
                  filters: ["pageData", "VoterID"],
                  dependsOn:[{region:"region.value"},{circle:"circle.value"},{subCircle:"subCircle.value"},{village:"village.value"}]
                },
                label: "display",
                value: "display"
              },
               placeHolder: "Aunty",
              name: "aunty",
              description: ""
            },

          ],
        }
  ],
  history: {
    perPage: 10,
    reportHeader: "Voters List",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    displayColumns: [
      {
        Header: "Sr. No",
        accessor: "srno",
        
      },
      {
        Header: "Voter ID",
        accessor: "VoterID",
      },
      // {
      //   Header: "E-Vol Name",
      //   accessor: "lastName",
        
      // },
      // {
      //   Header: "Voter Name",
      //   accessor: "VoterName",
        
      // },
      // {
      //   Header: "Family Head",
      //   accessor: "middleName"
      // },
      
      {
        Header: "Circle",
        accessor: "circle.value"
      },
      {
        Header: "Sub Circle",
        accessor: "subCircle.value"
      },
      {
        Header: "Village",
        accessor: "village.value"
      }, 
      {
        Header: "Booth",
        accessor: "booth.value"
      },             
      {
        Header: "Mobile Number",
        accessor: "mobilenumber1"
      },
      {
        Header: "Caste",
        accessor: "caste.value"
      },
      {
        Header: "Designation",
        accessor: "voterDesignation",
        show:false
      },
      {
        Header: "E-Vol",
        accessor: "evolunteer",
        show:false
      },             
      {
        Header: "P-Vol",
        accessor: "pvolunteer",
        show:false
      },
      {
        Header: "Reporter",
        accessor: "reporter",
        show:false
      },
      {
        Header: "Status",
        accessor: "status",
        show:false
      },
      {
        Header: "Outstation",
        accessor: "livingoutstation",
        show:false
      },
      
      
    ]
  },
};

export default voter;
